module.exports = __webpack_public_path__ + "img/katarina_bathrooms_3.7835c033.jpg";